import { useQuery } from "react-query";
import { getStudentCertificate, getStudentsCertificates } from "../services/school/student/getStudentByCode";
import { PagedRequestType } from "../types/PagedResults";


export const useGetStudentCertificate = (data: any, options:any = null) => {
    return useQuery([JSON.stringify(data), JSON.stringify(data)], () => getStudentCertificate(data), options?{...options}:{});
};


export const useGetStudentsCertificates = (data: PagedRequestType, options:any = null) => {
    return useQuery([JSON.stringify(data), JSON.stringify(data)], () => getStudentsCertificates(data), options?{...options}:{});
};


